/*
 * @flow
 */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchAggregateSelector } from '../reducers/aggregate';
import { fetchAggregate as fetchAggregateAction } from '../actions/aggregate';
import type { aggregateResponse } from '../model/aggregate';
import RatingSummary from '../components/AggregateBar/RatingSummary';
import CellSummary from '../components/AggregateBar/CellSummary';

type PropTypes = {
  location: {
    location_type: string,
    location_id: string,
  },
  loading: boolean,
  aggregate: ?aggregateResponse,
  fetchAggregate: Function,
};

export class AggregateBar extends React.PureComponent<PropTypes> {
  componentDidMount() {
    const { loading, aggregate, location, fetchAggregate } = this.props;
    if (!loading && (!aggregate || location.location_id !== aggregate.location_id)) {
      fetchAggregate({ locationType: location.location_type, locationId: location.location_id });
    }
  }

  render() {
    const { aggregate, loading } = this.props;

    if (loading || !aggregate) {
      return null;
    }

    return (
      <React.Fragment>
        <RatingSummary aggregate={aggregate} wrapper="li" />
        <CellSummary aggregate={aggregate} wrapper="li" />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loading, data: aggregate } = fetchAggregateSelector(state);
  const { locationType, locationId } = ownProps;
  return {
    location: { location_id: locationId, location_type: locationType },
    loading,
    aggregate,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAggregate: fetchAggregateAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AggregateBar);

export const RatingSummaryContainer = connect(mapStateToProps)(RatingSummary);
export const CellSummaryContainer = connect(mapStateToProps)(CellSummary);
